<template>
    <div class="wangEditor-container" @contextmenu="preventContextMenu">
        <div class="wangEditor-txt"  v-html="content" ref="wangEditor">
            {{content}}
        </div>
    </div>
</template>
<script>
    //import {JAjax,Base,getQueryObject} from '@commonjs/base.js';
   // import 'wangeditor';
    import { Base64 } from 'js-base64';
    export default {
        name: 'tutorials-show',
        props: {
            tutorContent:String
        },
        data(){
            return {
                content:''
            }
        },
        mounted(){
           this.setData();
        },
        methods:{
            setData () {
                this.content =  (this.tutorContent && Base64.decode(this.tutorContent))||"";
                setTimeout(() => {
                    let videos = this.$refs.wangEditor.getElementsByTagName('video');
                    for(let i = 0 ; i < videos.length; i++){
                        videos[i].setAttribute('controlsList', 'nodownload')
                    }
                }, 500)
            },
            preventContextMenu(e){
                e.preventDefault();
                return false;
            }
        },
        watch:{
            tutorContent(){
                this.setData();
            }
        }

    }
</script>
<style scoped>
    .wangEditor-container{
         background-color: transparent;
         border: none;
    }
    .wangEditor-txt{
        padding: 0;
    }

</style>
